import useId from '../utils/useId';
import * as React from 'react';
export const mgSvg = React.forwardRef(function mgSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0A376A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_mg__a_${id_0})`,
      d: 'M11.973 21.116a3.297 3.297 0 0 1-3.297-3.295c0-.857.333-1.646.878-2.235a7.324 7.324 0 0 1-.89-3.505c0-.196.012-.386.023-.58A7.123 7.123 0 0 0 4 18.192a7.126 7.126 0 0 0 10.594 6.223v-4.6a3.291 3.291 0 0 1-2.62 1.3Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_mg__b_${id_1})`,
      d: 'M11.973 14.53c.372 0 .727.058 1.06.176a3.55 3.55 0 0 1 2.97-5.505c1.43 0 2.66.851 3.226 2.068a7.127 7.127 0 0 1 4.08.233c-.297-3.778-3.456-6.752-7.306-6.752a7.336 7.336 0 0 0-6.449 10.838 3.291 3.291 0 0 1 2.42-1.055',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_mg__c_${id_2})`,
      d: 'M20.874 11.073a7.08 7.08 0 0 0-1.644.194c.2.45.318.954.318 1.48a3.5 3.5 0 0 1-.585 1.957 3.296 3.296 0 0 1 4.358 3.117 3.298 3.298 0 0 1-3.298 3.295 3.273 3.273 0 0 1-2.615-1.3v4.6a7.111 7.111 0 0 0 3.466.903 7.122 7.122 0 1 0 0-14.246Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_mg__a_${id_0}`,
          x1: 7.273,
          x2: 11.636,
          y1: 11.918,
          y2: 26.1,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#0076BF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#44C8F5',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_mg__b_${id_1}`,
          x1: 23.636,
          x2: 9.579,
          y1: 11.373,
          y2: 9.378,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#0076BF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#44C8F5',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_mg__c_${id_2}`,
          x1: 19.818,
          x2: 19.574,
          y1: 25.555,
          y2: 11.377,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#0076BF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#44C8F5',
        }),
      ),
    ),
  );
});
mgSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mg = {
  category: 'brand',
  colorable: false,
  name: 'mg',
  svg: mgSvg,
};
